<template>

  <div class="columns">
    <div class="column is-9">
      <div class="section-header">Error alert</div>
      <p class="help">Notify on critical failures.</p>
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field label="Notification service">
            <b-select v-model="formNotificationService.notificationService.error" expanded>
              <option :value="null">None</option>
              <option
                v-for="notificationService in notificationServices"
                :value="notificationService"
                :key="notificationService.alias">
                {{ notificationService.name }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-6" v-for="configOption in (formNotificationService.notificationService.error && formNotificationService.notificationService.error.notificationConfig) || []">
          <b-field :label="configOption.name">
            <b-select expanded v-model="formNotificationService.notificationServiceConfig.error[configOption.key]">
              <option
                v-for="(value, key) in configOption.options"
                :value="key"
                :key="key">
                {{ value }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>

      <hr>

      <div class="section-header">Warning alert</div>
      <p class="help">Notify on non-critical issues.</p>
      <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Notification service">
          <b-select v-model="formNotificationService.notificationService.warning" expanded>
            <option :value="null">None</option>
            <option
              v-for="notificationService in notificationServices"
              :value="notificationService"
              :key="notificationService.alias">
              {{ notificationService.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-6" v-for="configOption in (formNotificationService.notificationService.warning && formNotificationService.notificationService.warning.notificationConfig) || []">
        <b-field :label="configOption.name">
          <b-select expanded v-model="formNotificationService.notificationServiceConfig.warning[configOption.key]">
            <option
              v-for="(value, key) in configOption.options"
              :value="key"
              :key="key">
              {{ value }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>

    <hr>

    <div class="section-header">Test Result alert</div>
    <p class="help">Notify after each test with its result.</p>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Notification service">
          <b-select v-model="formNotificationService.notificationService.testResult" expanded>
            <option :value="null">None</option>
            <option
              v-for="notificationService in notificationServices"
              :value="notificationService"
              :key="notificationService.alias">
              {{ notificationService.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-6" v-for="configOption in (formNotificationService.notificationService.testResult && formNotificationService.notificationService.testResult.notificationConfig) || []">
        <b-field :label="configOption.name">
          <b-select expanded v-model="formNotificationService.notificationServiceConfig.testResult[configOption.key]">
            <option
              v-for="(value, key) in configOption.options"
              :value="key"
              :key="key">
              {{ value }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    </div>
    <div class="column is-3">
      <b-message :title="'Inherited alerts'" v-if="formTestType.testType.notificationServices">
        <div v-if="formTestType.testType.notificationServices.error">
          <b>Error alert - {{getNotificationServiceName(formTestType.testType.notificationServices.error.notificationServicesId)}}</b>
          <ul>
            <li v-for="(value, configKey) in formTestType.testType.notificationServices.error.config">
              - {{getNotificationConfigParamName(formTestType.testType.notificationServices.error.notificationServicesId, configKey)}}: {{value}}
            </li>
          </ul>
        </div>
        <br>
        <div v-if="formTestType.testType.notificationServices.warning">
          <b>Warning alert - {{getNotificationServiceName(formTestType.testType.notificationServices.warning.notificationServicesId)}}</b>
          <ul>
            <li v-for="(value, configKey) in formTestType.testType.notificationServices.warning.config">
              - {{getNotificationConfigParamName(formTestType.testType.notificationServices.warning.notificationServicesId, configKey)}}: {{value}}
            </li>
          </ul>
        </div>
        <br>
        <div v-if="formTestType.testType.notificationServices.testResult">
          <b>Test Result alert - {{getNotificationServiceName(formTestType.testType.notificationServices.testResult.notificationServicesId)}}</b>
          <ul>
            <li v-for="(value, configKey) in formTestType.testType.notificationServices.testResult.config">
              - {{getNotificationConfigParamName(formTestType.testType.notificationServices.testResult.notificationServicesId, configKey)}}: {{value}}
            </li>
          </ul>
        </div>
      </b-message>
    </div>
  </div>

</template>

<script>
import NotificationServicesService from "@/services/NotificationServicesService";

export default {
  name: 'Alert',
  data () {
    return {
      formNotificationService: {},
      formTestType: {},
      notificationServices: []
    }
  },

  methods: {
    getNotificationServices() {
      NotificationServicesService.getList()
        .then(response => {
          this.notificationServices = response.data
        })
    },

    getNotificationServiceName(notificationServiceId) {
      for (let notificationService of this.notificationServices) {
        if (notificationService._id === notificationServiceId) {
          return notificationService.name
        }
      }
    },

    getNotificationConfigParamName(notificationServiceId, configParamKey) {
      for (let notificationService of this.notificationServices) {
        if (notificationService._id === notificationServiceId) {
          for (let notificationConfig of notificationService.notificationConfig) {
            if (notificationConfig.key === configParamKey) {
              return notificationConfig.name
            }
          }
        }
      }
    }
  },

  created() {
    this.getNotificationServices()
    this.formNotificationService = this.$store.getters['testJob/formNotificationService'];
    this.formTestType = this.$store.getters['testJob/formTestType'];
  }
}
</script>
